import { environmentConfiguration } from 'config/environment'
import { readFromStorage, writeToStorage } from 'lib/storage'
import { uniqueId } from 'lib/unique_id'
import { postUpvote, getPlaceInfo } from 'lib/ajax'


export default class Widget {

  constructor(props, onStateChange) {
    this._persistedProperites = ["upvoted", "downvoted"]

    this.state = this._getDefaultState(props);
    this.onStateChange = onStateChange
  }

  init() {
    getPlaceInfo(this.widgetId(), (widgetData) => {
      this._setState({
        name:    widgetData.name,
        upvotes: widgetData.upvote_count
      })

      this.state.upvoted && this.animateHeart('end')
    })
  }

  templateContext() {
    return({ ...this._getState(), ...this._computedProperties(this._getState()) })
  }

  animateHeart(position) {
    this.state.element.setAttribute('data-animate', position);
  }

  toggleVote() {
    this._upvoted() ? this._downvote() : this._upvote()
  }

  toggleModal() {
    this._setState({
      modalOpen: !this._modalOpen(),
      scrollPos: !this._modalOpen() ? document.documentElement.scrollTop || document.body.scrollTop : this._getState().scrollPos
    })

    // set scroll position
    this._scrollTo(!this._modalOpen() ? this._getState().scrollPos : 0)
  }

  widgetId() {
    return this._getState().widgetId
  }

  // Private

  _scrollTo(pos) {
    document.documentElement.scrollTop = document.body.scrollTop = pos
  }

  _getDefaultState(props) {
    return {
      element:   props.element,
      id:        uniqueId(),
      widgetId:  props.widgetId,
      upvotes:   0,
      upvoted:   readFromStorage(props.widgetId, "upvoted") === "true",
      downvoted: readFromStorage(props.widgetId, "downvoted") === "true",
      modalOpen: false,
      scrollPos: 0,
      name:      null,
      tpmHost:   environmentConfiguration.tpmHost
    }
  }

  _setState(stateUpdates) {
    this.state = { ...this.state, ...stateUpdates }
    const state = this._getState()

    for(let propertyIndex in this._persistedProperites) {
      let property = this._persistedProperites[propertyIndex]
      writeToStorage(this.widgetId(), property, this[`_${property}`]())
    }

    if (this.onStateChange) this.onStateChange(state)
    return state
  }

  _getState() {
    return { ...this.state }
  }

  _computedProperties(state) {
    return {
      upvotedByAnybody: state.upvotes > 0,
      upvoteStatNumber: state.upvotes,
      upvoteStatWord:   state.upvotes === 1 ? "person" : "people",
      upvoteStatClass:  state.upvoted ? "-upvoted" : ""
    };
  }

  _upvote() {
    this.animateHeart('begin')
    this._setState({ upvoted: true, upvotes: this._upvoteCount() + 1 })

    if (!this._downvoted()) postUpvote(this.widgetId())
  }

  _downvote() {
    this._setState({ upvoted: false, downvoted: true, upvotes: this._upvoteCount() - 1 })
  }

  _upvoteCount() {
    return this._getState().upvotes
  }

  _upvoted() {
    return this._getState().upvoted
  }

  _downvoted() {
    return this._getState().downvoted
  }

  _modalOpen() {
    return this._getState().modalOpen
  }

}



/** WEBPACK FOOTER **
 ** ./app/models/widget.js
 **/